import { Blob } from './blob';
import { MockBlob } from './mock-blob';

const BlobLoader = (isMock, include = true) => {
    if (!include) return {};

    return isMock ? MockBlob : Blob;
};

export { BlobLoader };
